import type { LocalizedText, Translate } from '@/entities/moderation';
import { LOCALE_ORDER, localeLine } from '../../../lib/locales';
import { InfoRow, StackedRow } from '../review-modal-shell';

/** All three locales of a localized field — empty reads as `—`, never hidden. */
export function LocalizedRows({
  value,
  t,
  stacked = false,
}: {
  value: LocalizedText | undefined;
  t: Translate;
  /** Label above a full-width value (long text) instead of two columns. */
  stacked?: boolean;
}) {
  return (
    <dl className="flex flex-col gap-2.5">
      {LOCALE_ORDER.map(({ key, labelKey, fallback }) =>
        stacked ? (
          <StackedRow
            key={key}
            label={t(labelKey, fallback)}
            value={localeLine(value, key)}
          />
        ) : (
          <InfoRow
            key={key}
            label={t(labelKey, fallback)}
            value={localeLine(value, key)}
          />
        ),
      )}
    </dl>
  );
}
